import React from 'react';
import styles from "./NoContent.module.scss";
import { NoDataIcon } from '../../../assets/icons/svgicons';

const NoContent = ({ variant, className, content }) => {
    return (
        <>
            <div
                className={`${styles.no_content} ${className || ""}`}
                data-variant={variant}
            >
                <span className={styles.icon}><NoDataIcon /></span>
                <h4 className={variant === "large" ? "h2" : variant === "medium" ? "h3" : ""}>Nothing to see here!</h4>
                {content && <p className={variant === "large" ? "h6" : variant === "medium" ? "p" : ""}>{content}</p>}
            </div>
        </>
    )
}

export default NoContent
